import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { Grid, GridItem } from "@ecco/ui/grid";
import Barcode from "react-barcode";
import { CommonCMS } from "@lib/constants/contentful";
import { styles } from "./EccoClubCardsStyles";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { BoxWithRibbon } from "../BoxWithRIbbon";
import { hasPointsAndTiers } from "@lib/utils/loyalty";

const MembershipDetails = ({ tierLevel, pointsBalance, membershipId }) => {
    const { getMultiple } = useMicrocopy();

    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.loyalty.tierLevel,
            CommonCMS.loyalty.pointsBalance,
            CommonCMS.loyalty.eccoPass,
            CommonCMS.loyalty.membershipId,
            CommonCMS.loyalty.showEccoPass,
        ]);
    })();

    return (
        <BoxWithRibbon>
            {hasPointsAndTiers && (
                <Box paddingBottom={[2, 4, 6]} style={styles.membershipInfoContainer}>
                    <Grid templateColumns={["1fr", "1fr 1fr"]} gap={[4, 8, 12]} mb={4}>
                        <MembershipInfo
                            label={microcopies[CommonCMS.loyalty.tierLevel]}
                            value={tierLevel}
                        />
                        <MembershipInfo
                            label={microcopies[CommonCMS.loyalty.pointsBalance]}
                            value={pointsBalance}
                        />
                    </Grid>
                </Box>
            )}
            <Box paddingTop={hasPointsAndTiers ? [2, 4, 6] : 0} maxWidth={["100%", "60%"]}>
                <Text fontWeight="semibold" fontSize="mobileBodyB2">
                    {microcopies[CommonCMS.loyalty.eccoPass]}
                </Text>
                <Text fontSize={["mobileBodyB3", "desktopBodyB3"]} marginTop="2">
                    {microcopies[CommonCMS.loyalty.showEccoPass]}
                </Text>
                <Barcode value={membershipId} displayValue={false} />
                <Text fontWeight="semibold" fontSize="mobileBodyB2" marginTop="3">
                    {microcopies[CommonCMS.loyalty.membershipId]}
                </Text>
                <Text fontWeight="bold" fontSize={["mobileH1", "desktopH1"]}>
                    {membershipId}
                </Text>
            </Box>
        </BoxWithRibbon>
    );
};

const MembershipInfo = ({ label, value }: { label: string; value: string }) => (
    <GridItem>
        <Text fontWeight="bold" fontSize="mobileBodyB1">
            {label}
        </Text>
        <Text fontWeight="bold" fontSize={["mobileH1", "desktopH1"]}>
            {value}
        </Text>
    </GridItem>
);

export default MembershipDetails;
